import { useSetAtom } from 'jotai';
import { useState } from 'react';
import { state } from '~/storage';

export function useCatalogue(getSliderLeftPosition: () => number, canvasInner: HTMLDivElement | null) {
	const [isSliderExpanded, setIsSliderExpanded] = useState(false);
	const setIsBodyNoneScroll = useSetAtom(state.isBodyNoneScroll);

	const collapsCatalogue = () => {
		if (!canvasInner) return;
		const inner = canvasInner;

		const parent = inner.parentElement;
		if (!parent) return;
		const parentRect = parent.getBoundingClientRect();
		setIsBodyNoneScroll(false);

		inner.style.overflow = '';
		inner.style.top = `${parentRect.top}px`;
		inner.style.height = `${parentRect.height}px`;
		inner.style.top = `${parentRect.top}px`;
		inner.style.height = `${parentRect.height}px`;

		setTimeout(() => {
			inner.style.position = 'static';
			inner.style.top = '';
			inner.style.left = `${getSliderLeftPosition()}px`;
			inner.style.height = '';
			inner.style.width = '';
			setTimeout(() => {
				inner.style.flexDirection = 'row';
				setIsSliderExpanded(false);

				setTimeout(() => {
					inner.style.position = '';
					inner.style.flexDirection = '';
					parent.style.height = '';
				});
			}, 50);
		}, 300);
	};

	const expandCatalogue = () => {
		if (!canvasInner) return;
		const inner = canvasInner;
		const innerRect = inner.getBoundingClientRect();
		const footer = document?.getElementById('service-footer');

		if (!footer) return;

		const parent = inner.parentElement;
		if (!parent) return;
		const parentRect = parent.getBoundingClientRect();

		parent.style.height = `${innerRect.height}px`;
		inner.style.transition = 'none';
		setTimeout(() => {
			inner.style.left = `${parentRect.left}px`;
			inner.style.top = `${parentRect.top}px`;
			inner.style.width = `${parentRect.width}px`;
			inner.style.height = `${innerRect.height}px`;
			setIsSliderExpanded(true);

			setTimeout(() => {
				inner.style.transition = '';
				inner.style.top = '0px';
				inner.style.height = `${window.innerHeight - footer.offsetHeight}px`;

				setTimeout(() => {
					inner.style.overflowY = 'scroll';
				}, 50);
				setIsBodyNoneScroll(true);
			}, 50);
		}, 300);
	};

	return { isSliderExpanded, collapsCatalogue, expandCatalogue };
}
